// ─── Channels ────────────────────────────────────────────────────────────────

export const CHANNELS = {
  // Notifications in-app par utilisateur
  userNotifications: (userId: number) => `notifications.${userId}`,

  // Annonces ciblées par utilisateur
  announcements: (userId: number) => `announcements.${userId}`,

  // Messages et typing d'une conversation (id NUMÉRIQUE)
  conversation: (conversationId: number) => `conversations.${conversationId}`,

  // Sessions live (id NUMÉRIQUE — pas uuid)
  liveSession: (sessionId: number) => `live-sessions.${sessionId}`,
} as const;

// ─── Events ──────────────────────────────────────────────────────────────────
// Préfixés par "." — convention Laravel Broadcasting côté client

export const EVENTS = {
  notifications: {
    created: ".notification.created",
    unreadCountUpdated: ".conversation.unread-count.updated",
  },

  announcements: {
    published: ".announcement.published",
  },

  conversation: {
    messageSent: ".message.sent",
    messageUpdated: ".message.updated",
    messageDeleted: ".message.deleted",
    userTyping: ".user.typing",
  },

  liveSession: {
    started: ".live-session.started",
    ended: ".live-session.ended",
    participantJoined: ".live-session.participant-joined",
    participantLeft: ".live-session.participant-left",
    metricsUpdated: ".live-session.metrics-updated",
    recordingStarted: ".live-session.recording-started",
    recordingStopped: ".live-session.recording-stopped",
    recordingStoppedUnexpectedly: ".live-session.recording-stopped-unexpectedly",
    participantEvictedDuplicateConnection: ".live-session.participant-evicted-duplicate-connection",
    handRaised: ".live-session.hand-raised",
    handLowered: ".live-session.hand-lowered",
    handStateSynced: ".live-session.hand-state-synced",
    microphoneUpdated: ".live-session.microphone-updated",
    unmuteRequested: ".live-session.unmute-requested",
    teacherPresenceUpdated: ".live-session.teacher-presence-updated",
  },
} as const;
